<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <form novalidate @submit.prevent="submitEditWorkplace">
      <HeadingOne>お勤め先情報の変更</HeadingOne>

      <ErrorsAlert
        :errors="errors"
        :column-only="true"
        :items="inputItemsMb"
      ></ErrorsAlert>

      <WizardGroup class="_mb-md-60 _mb-sm-20">
        <MainWizard :active-index="0" type="useremploy"></MainWizard>
      </WizardGroup>

      <p>変更内容をご入力のうえ、「確認画面へ」を押してください。</p>

      <section>
        <TableGroup>
          <HeadingTwo>お勤め先情報</HeadingTwo>

          <TableBox>
            <TableBody>
              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">職業</TableHeader>
                <TableData :has-error="errors['work_form']">
                  <InputGroup :errors="errors" :prop-names="['work_form']">
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(workForm, index) in workForms"
                        :id="'workForm' + index"
                        :key="'workForm' + index"
                        v-model="userData.work_form"
                        name="workForm"
                        :value="workForm['value']"
                        :label="workForm['name']"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                  <template v-if="showWorkFormMessage(userData.work_form)">
                    <ListGroup class="-note _mt-10">
                      <ListItem class="-note"
                        >定期収入のない方はお申し込みいただけません、お勤め先を必ずご記入ください。</ListItem
                      >
                    </ListGroup>
                  </template>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">業種</TableHeader>
                <TableData :has-error="errors['biz_type']">
                  <InputGroup :errors="errors" :prop-names="['biz_type']">
                    <BtnSelect id="biz_type" v-model="userData.biz_type">
                      <option
                        v-for="(bizType, index) in bizTypes"
                        :key="'bizType' + index"
                        :value="bizType['value']"
                      >
                        {{ bizType["name"] }}
                      </option>
                    </BtnSelect>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">職種</TableHeader>
                <TableData :has-error="errors['job_type']">
                  <InputGroup :errors="errors" :prop-names="['job_type']">
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(jobType, index) in jobTypes"
                        :id="'jobType' + index"
                        :key="'jobType' + index"
                        v-model="userData.job_type"
                        name="jobType"
                        :value="jobType['value']"
                        :label="jobType['name']"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >お勤め先<small class="moji">【全角】</small>
                  <TooltipsItem placement="righttop">
                    お勤め先名称は（株）（有）など使用せず、正式名称をご記入ください。
                  </TooltipsItem>
                </TableHeader>
                <TableData :has-error="errors['office_nm']">
                  <InputGroup :errors="errors" :prop-names="['office_nm']">
                    <InputGroup>
                      <InputItem
                        id="office_nm"
                        v-model="userData.office_nm"
                        type="text"
                        class="-lg"
                        :maxlength="20"
                      ></InputItem>
                      <InputLabel
                        >入力例：auフィナンシャルサービス株式会社</InputLabel
                      >
                    </InputGroup>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >お勤め先電話番号<small class="moji">【半角数字】</small>
                </TableHeader>
                <TableData :has-error="errors['office_phone']">
                  <InputGroup :errors="errors" :prop-names="['office_phone']">
                    <input-phone
                      id="office_phone"
                      :phone="{
                        phone1: userData.office_phone_1,
                        phone2: userData.office_phone_2,
                        phone3: userData.office_phone_3,
                      }"
                      @input="setPhone"
                    ></input-phone>
                    <InputLabel>入力例：03-****-****</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >所属部署<small class="moji">【全角】</small>
                </TableHeader>
                <TableData :has-error="errors['office_depart']">
                  <InputGroup :errors="errors" :prop-names="['office_depart']">
                    <InputItem
                      id="office_depart"
                      v-model="userData.office_depart"
                      type="text"
                      class="-md"
                      :maxlength="20"
                    ></InputItem>
                    <InputLabel
                      >入力例：
                      営業部&nbsp;&nbsp;※所属部署が不明な場合は、「なし」とご記入ください。</InputLabel
                    >
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm"
                  >入社年月<small class="moji">【半角数字】</small>
                </TableHeader>
                <TableData :has-error="errors['nsh_ngt']">
                  <InputGroup :errors="errors" :prop-names="['nsh_ngt']">
                    <inputgroup-append>
                      <InputItem
                        id="nshNgtYyyy"
                        v-model="nshNgtYyyy"
                        type="text"
                        class="-xs"
                        :maxlength="4"
                        @change="setNshNgt"
                      ></InputItem>
                      <input-append>年</input-append>
                      <InputItem
                        id="nshNgtMm"
                        v-model="nshNgtMm"
                        type="text"
                        class="-xs"
                        :maxlength="2"
                        @change="setNshNgt"
                      ></InputItem>
                      <input-append>月~</input-append>
                    </inputgroup-append>
                    <InputLabel>入力例：2018年4月~</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">社員数 </TableHeader>
                <TableData :has-error="errors['staff_num']">
                  <InputGroup :errors="errors" :prop-names="['staff_num']">
                    <BtngroupRadio>
                      <BtnRadio
                        v-for="(staffNum, index) in staffNums"
                        :id="'staffNum' + index"
                        :key="'staffNum' + index"
                        v-model="userData.staff_num"
                        name="staffNum"
                        :value="staffNum['value']"
                        :label="staffNum['name']"
                      >
                      </BtnRadio>
                    </BtngroupRadio>
                  </InputGroup>
                </TableData>
              </TableRow>

              <TableRow>
                <TableHeader badge="必須" badge-size="-sm">
                  年収<small
                    >（税込）<small class="moji">【半角数字】</small></small
                  >
                  <TooltipsItem placement="righttop">
                    収入証明書をご提出いただいた場合、ご入力いただいた年収とは異なる場合があります。
                  </TooltipsItem>
                </TableHeader>
                <TableData :has-error="errors['gross_salary']">
                  <InputGroup :errors="errors" :prop-names="['gross_salary']">
                    <inputgroup-append>
                      <InputItem
                        id="grossSalary"
                        v-model="input_gross_salary"
                        type="text"
                        class="-sm"
                        :maxlength="4"
                      ></InputItem>
                      <input-append>万円</input-append>
                    </inputgroup-append>
                    <InputLabel
                      >300万円の場合「300」※1万円単位、1万円未満の端数は切り捨てとなります。</InputLabel
                    >
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
            <!-- TableBody -->
          </TableBox> </TableGroup
        ><!-- form -->

        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitEditWorkplace">
              確認画面へ
            </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb023"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </section>
    </form>
  </div>
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  editWorkplaceLambdaInvoke,
  getUserDataForMemberLambdaInvoke,
} from "@/utils/LambdaHelper";
import {
  workForms,
  bizTypes,
  jobTypes,
  staffNums,
  inputItemsMb,
} from "@/constants/constant";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import {
  setNshNgtYyyy,
  setNshNgtMm,
  setNshNgt,
  setGrossSalary,
  setOfficePhone,
  showWorkFormMessage,
} from "@/utils/UserData";
import HeadingOne from "@/components/heading/HeadingOne";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnRadio from "@/components/button/BtnRadio";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputItem from "@/components/input/InputItem";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputAppend from "@/components/input/InputAppend";
import InputLabel from "@/components/input/InputLabel";
import BtngroupRadio from "@/components/button/BtngroupRadio";
import BtnSelect from "@/components/button/BtnSelect";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableGroup from "@/components/tables/TableGroup";
import InputPhone from "@/components/input/InputPhone";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb025",
  components: {
    ErrorsAlert,
    ListItem,
    ListGroup,
    InputPhone,
    TableGroup,
    WizardGroup,
    MainWizard,
    InputLabel,
    InputAppend,
    InputgroupAppend,
    InputGroup,
    InputItem,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtnRadio,
    HeadingTwo,
    BtngroupDouble,
    TooltipsItem,
    HeadingOne,
    BtnMain,
    BtnBack,
    BtngroupRadio,
    BtnSelect,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お勤め先情報の変更｜お客さま情報の確認・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      setNshNgtYyyy,
      setNshNgtMm,
      setNshNgt,
      setGrossSalary,
      setOfficePhone,
      showWorkFormMessage,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "お勤め先情報の変更",
          active: true,
        },
      ],
      workForms: workForms,
      bizTypes: bizTypes,
      jobTypes: jobTypes,
      staffNums: staffNums,
      errors: {},
      isDisabled: false,
      input_gross_salary: "",
      userData: {
        work_form: "",
        biz_type: "",
        job_type: "",
        office_nm: "",
        office_phone_1: "",
        office_phone_2: "",
        office_phone_3: "",
        office_depart: "",
        nsh_ngt: "",
        staff_num: "",
        gross_salary: "",
      },
      nshNgtYyyy: "",
      nshNgtMm: "",
      inputItemsMb: inputItemsMb,
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
          this.nshNgtYyyy = setNshNgtYyyy(this.userData.nsh_ngt);
          this.nshNgtMm = setNshNgtMm(this.userData.nsh_ngt);
          if (this.userData.gross_salary) {
            this.input_gross_salary = this.userData.gross_salary / 10000;
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    setPhone(data) {
      this.userData = {
        ...this.userData,
        ...setOfficePhone(data.phone1, data.phone2, data.phone3),
      };
    },
    submitEditWorkplace: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.userData.nsh_ngt = setNshNgt(this.nshNgtYyyy, this.nshNgtMm);
        this.userData.gross_salary = setGrossSalary(this.input_gross_salary);
        initCredentials()
          .then(() => {
            editWorkplaceLambdaInvoke(this.userData)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "mb028" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
